<!-- employee-details.component.html -->
<div *ngIf="!isDashboard" class="header-container">
  <app-header></app-header>
</div>
<div class="flex flex-col min-h-screen bg-[#ECF7FF] font-sans">
  <main class="flex-grow container mx-auto w-[80%] px-6 py-20">
    <div class="bg-white p-8 shadow-md" (click)="closeOptionsModal()">
      <!-- <app-stepper [currentStep]="activeStep" *ngIf="!isActive"></app-stepper> -->

      <div class="bg-white text-[#667085] pt-6">
        <div class="flex justify-between mb-6">
          <div>
            <h2 class="text-black text-xl font-bold">Members list</h2>
            <p class="text-gray-600">Here are all the members added by you</p>
          </div>
          <div class="flex space-x-4 items-center">
            <button
              class="px-4 py-2 flex items-center text-gray-700 hover:bg-gray-50 rounded-md border border-gray-200"
              (click)="
                AddEmployeeAndDependency(selectedRowIndex!, null, false, false)
              "
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 4V16M4 10H16"
                  stroke="#344054"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <span class="text-gray-700 ml-2">Add Employee</span>
            </button>
            <button
              class="px-4 items-center py-2 flex hover:bg-gray-50 rounded-md border border-gray-200"
              (click)="deleteSelected()"
              *ngIf="!isActive"
            >
              <svg
                width="18"
                height="20"
                viewBox="0 0 18 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.3333 4.99984V4.33317C12.3333 3.39975 12.3333 2.93304 12.1517 2.57652C11.9919 2.26292 11.7369 2.00795 11.4233 1.84816C11.0668 1.6665 10.6001 1.6665 9.66667 1.6665H8.33333C7.39991 1.6665 6.9332 1.6665 6.57668 1.84816C6.26308 2.00795 6.00811 2.26292 5.84832 2.57652C5.66667 2.93304 5.66667 3.39975 5.66667 4.33317V4.99984M7.33333 9.58317V13.7498M10.6667 9.58317V13.7498M1.5 4.99984H16.5M14.8333 4.99984V14.3332C14.8333 15.7333 14.8333 16.4334 14.5608 16.9681C14.3212 17.4386 13.9387 17.821 13.4683 18.0607C12.9335 18.3332 12.2335 18.3332 10.8333 18.3332H7.16667C5.76654 18.3332 5.06647 18.3332 4.53169 18.0607C4.06129 17.821 3.67883 17.4386 3.43915 16.9681C3.16667 16.4334 3.16667 15.7333 3.16667 14.3332V4.99984"
                  stroke="#344054"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span class="text-gray-700 ml-2">Delete Selected</span>
            </button>
            <button
              class="px-4 py-2 flex items-center text-gray-700 hover:bg-gray-50 rounded-md border border-gray-200"
              (click)="applyFilters()"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 10H15M2.5 5H17.5M7.5 15H12.5"
                  stroke="#344054"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span class="text-gray-700 ml-2">Filters</span>
            </button>
          </div>
        </div>

        <div
          *ngIf="tableData.length === 0"
          class="text-center py-8 text-gray-500 border rounded-lg"
        >
          No members found. Please add employees and their dependents.
        </div>

        <div class="space-y-4">
          <!-- Employee Cards -->
          <div
            *ngFor="
              let employee of tableData | filter : { type: 'Employee' };
              let i = index
            "
            class="border rounded-lg overflow-hidden shadow-sm"
          >
            <!-- Employee Card Header -->
            <div
              class="bg-gray-50 px-4 py-3 border-b flex justify-between items-center"
            >
              <div class="flex items-center space-x-3">
                <div
                  *ngIf="!isActive"
                  class="custom-checkbox"
                  [class.checked]="isSelected(employee)"
                  (click)="toggleCheckbox(employee)"
                >
                  <svg
                    *ngIf="isSelected(employee)"
                    width="12"
                    height="9"
                    viewBox="0 0 12 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.6673 1.5L4.25065 7.91667L1.33398 5"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <h3 class="font-medium text-gray-900">
                  {{ employee.firstNameEn + " " + employee.lastNameEn }}
                </h3>
                <span
                  class="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800"
                  >Employee</span
                >
              </div>
              <div class="flex items-center space-x-2">
                <button
                  *ngIf="!isActive"
                  (click)="toggleOptions($event, i, null, false)"
                  class="text-gray-500 hover:text-gray-700 p-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <!-- Employee Details -->
            <div class="p-4" style="padding: 2rem 4rem">
              <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <p class="text-sm text-gray-500">ID Number</p>
                  <p class="font-medium">{{ employee.idNumber }}</p>
                </div>
                <div>
                  <p class="text-sm text-gray-500">Date of Birth</p>
                  <p class="font-medium">
                    {{ formatDate(employee.dateOfBirth) }}
                  </p>
                </div>
                <div>
                  <p class="text-sm text-gray-500">Mobile Number</p>
                  <p class="font-medium">
                    {{ employee.mobileNumber || "N/A" }}
                  </p>
                </div>
                <div>
                  <p class="text-sm text-gray-500">Insurance Class</p>
                  <!-- <select
                    *ngIf="!isActive"
                    [(ngModel)]="employee.insuranceClass"
                    (change)="onInsuranceClassChange($event, i)"
                    class="block w-full mt-1 border-gray-300 rounded-md border-[1px] p-[2px] focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  >
                    <option
                      class="text-[#667085]"
                      *ngFor="let classOption of insuranceClasses"
                      [value]="classOption"
                    >
                      {{ classOption }}
                    </option>
                  </select> -->
                  <p class="font-medium">
                    {{ employee.insuranceClass | insuranceClass }}
                  </p>
                </div>
                <div>
                  <p class="text-sm text-gray-500">Marital Status</p>
                  <p class="font-medium">
                    {{ employee.married ? "Married" : "Single" }}
                  </p>
                </div>
                <div>
                  <p class="text-sm text-gray-500">Declaration</p>
                  <p class="font-medium">
                    {{
                      employee.declarationCompleted ? "Completed" : "Pending"
                    }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Dependents Section -->
            <div
              *ngIf="
                employee.dependentList && employee.dependentList.length > 0
              "
              class="border-t dependents-section"
            >
              <!-- <div class="px-4 py-2 bg-gray-50">
                <h4 class="text-sm font-medium text-gray-700">Dependents</h4>
              </div> -->
              <div class="divide-y">
                <div
                  *ngFor="
                    let dependent of employee.dependentList;
                    let j = index
                  "
                  class="p-4"
                >
                  <div
                    class="flex justify-between items-start"
                    style="margin-bottom: 1%"
                  >
                    <div class="flex items-center space-x-3">
                      <div
                        *ngIf="!isActive"
                        class="custom-checkbox"
                        [class.checked]="isSelected(dependent)"
                        (click)="toggleCheckbox(dependent)"
                      >
                        <svg
                          *ngIf="isSelected(dependent)"
                          width="12"
                          height="9"
                          viewBox="0 0 12 9"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.6673 1.5L4.25065 7.91667L1.33398 5"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div class="px-4 py-2 bg-gray-50 flex">
                        <h5 style="margin-right: 5px" class="font-medium">
                          {{ dependent.nameEn }}
                        </h5>
                        <span
                          class="text-xs px-2 py-1 rounded-full bg-purple-100 text-purple-800"
                          >Dependent</span
                        >
                      </div>
                    </div>
                    <button
                      *ngIf="!isActive"
                      (click)="toggleOptions($event, i, j, true)"
                      class="text-gray-500 hover:text-gray-700 p-1"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                        />
                      </svg>
                    </button>
                  </div>
                  <hr class="my-2 border-gray-200" />
                  <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2 pl-8">
                    <div>
                      <p class="text-sm text-gray-500">ID Number</p>
                      <p class="font-medium">{{ dependent.idNumber }}</p>
                    </div>
                    <div>
                      <p class="text-sm text-gray-500">Date of Birth</p>
                      <p class="font-medium">
                        {{ formatDate(dependent.dateOfBirth) }}
                      </p>
                    </div>
                    <div>
                      <p class="text-sm text-gray-500">Relation</p>
                      <p class="font-medium">
                        {{ dependent.relation || "N/A" }}
                      </p>
                    </div>
                    <div>
                      <p class="text-sm text-gray-500">Insurance Class</p>
                      <!-- <select
                        *ngIf="!isActive"
                        [(ngModel)]="dependent.insuranceClass"
                        (change)="
                          onInsuranceClassChange(
                            $event,
                            findIndex(dependent.idNumber)
                          )
                        "
                        class="block w-full mt-1 border-gray-300 rounded-md border-[1px] p-[2px] focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      >
                        <option
                          class="text-[#667085]"
                          *ngFor="let classOption of insuranceClasses"
                          [value]="classOption"
                        >
                          {{ classOption }}
                        </option>
                      </select> -->
                      <p class="font-medium">
                        {{ dependent.insuranceClass | insuranceClass }}
                      </p>
                    </div>
                    <div>
                      <p class="text-sm text-gray-500">Marital Status</p>
                      <p class="font-medium">
                        {{ dependent.married ? "Married" : "Single" }}
                      </p>
                    </div>
                    <div>
                      <p class="text-sm text-gray-500">Declaration</p>
                      <p class="font-medium">
                        {{
                          dependent.declarationCompleted
                            ? "Completed"
                            : "Pending"
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Options Modal -->
        <div
          *ngIf="showOptionsModal"
          [style.top]="modalPosition.top"
          [style.left]="modalPosition.left"
          class="fixed z-10 mt-2 w-40 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5"
          style="position: absolute"
        >
          <div class="py-1">
            <button
              (click)="
                AddEmployeeAndDependency(
                  selectedRowIndex!,
                  selectedDependentIndex,
                  true,
                  !showAddDependentModal
                )
              "
              class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Edit
            </button>
            <button
              (click)="deleteItem(selectedRowIndex!, selectedDependentIndex)"
              class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Delete
            </button>
            <button
              *ngIf="showAddDependentModal"
              (click)="
                AddEmployeeAndDependency(
                  selectedRowIndex!,
                  selectedDependentIndex,
                  false,
                  true
                )
              "
              class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Add Dependent
            </button>
          </div>
        </div>
      </div>

      <div
        class="mt-6 flex justify-between"
        [ngClass]="{
          'justify-between': !isActive,
          'justify-center': isActive
        }"
      >
        <button
          *ngIf="!isActive"
          class="px-6 py-2 border rounded-md text-gray-700 hover:bg-gray-50"
          (click)="back()"
        >
          Back
        </button>
        <div
          *ngIf="totalPages > 1"
          class="flex justify-center items-center space-x-2 mt-4"
        >
          <button
            (click)="onPageChange(currentPage - 1)"
            [disabled]="currentPage === 0"
            class="px-3 py-1 bg-white border border-gray-300 rounded-md disabled:opacity-50"
          >
            Previous
          </button>
          <ng-container *ngFor="let page of pages">
            <button
              (click)="onPageChange(page)"
              [class.bg-blue-600]="currentPage === page"
              [class.text-gray-300]="currentPage === page"
              [class.text-gray-700]="currentPage !== page"
              class="px-3 py-1 bg-white border border-gray-300 rounded-md"
            >
              {{ page + 1 }}
            </button>
          </ng-container>
          <button
            (click)="onPageChange(currentPage + 1)"
            [disabled]="currentPage === totalPages - 1"
            class="px-3 py-1 bg-white border border-gray-300 rounded-md disabled:opacity-50"
          >
            Next
          </button>
        </div>

        <button
          *ngIf="!isActive"
          class="px-6 py-2 bg-primary-color text-white rounded-md hover:bg-blue-700"
          (click)="continue()"
        >
          Continue
        </button>
      </div>
    </div>
  </main>
</div>

<app-footer *ngIf="!isDashboard" layout="slim"></app-footer>
